import { Helmet } from 'react-helmet-async'

function LandingMetaTags () {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>
        Engineers Knowledge Base - KI-gestützte Wissensdatenbank für
        Servicetechniker
      </title>
      <meta
        name='title'
        content='Engineers Knowledge Base - KI-gestützte Wissensdatenbank für Servicetechniker'
      />
      <meta
        name='description'
        content='Die intelligente Wissensdatenbank für Servicetechniker. Sparen Sie Zeit, reduzieren Sie Standzeiten und bewahren Sie wertvolles Know-how – auch bei Mitarbeiterwechsel. KI-gestützte Suche, zentrale Wissensdatenbank, DSGVO-konform.'
      />
      <meta
        name='keywords'
        content='Wissensdatenbank, Servicetechniker, KI-Suche, Troubleshooting, Fehlercode, Service-Manual, Wissensmanagement, Field Service, Techniker-Wissen, Knowledge Base, DSGVO, Azure Deutschland'
      />
      <meta name='author' content='Engineers Knowledge Base' />
      <meta name='robots' content='index, follow' />
      <meta name='language' content='German' />
      <meta name='revisit-after' content='7 days' />

      {/* Open Graph / Facebook */}
      <meta property='og:type' content='website' />
      <meta
        property='og:url'
        content='https://engknowledge.com/'
      />
      <meta
        property='og:title'
        content='Engineers Knowledge Base - KI-gestützte Wissensdatenbank für Servicetechniker'
      />
      <meta
        property='og:description'
        content='Die intelligente Wissensdatenbank für Servicetechniker. Sparen Sie Zeit, reduzieren Sie Standzeiten und bewahren Sie wertvolles Know-how – auch bei Mitarbeiterwechsel.'
      />
      <meta
        property='og:image'
        content='https://engknowledge.com/founder-photo.jpg'
      />
      <meta property='og:locale' content='de_DE' />
      <meta property='og:site_name' content='Engineers Knowledge Base' />

      {/* Twitter */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta
        name='twitter:url'
        content='https://engknowledge.com/'
      />
      <meta
        name='twitter:title'
        content='Engineers Knowledge Base - KI-gestützte Wissensdatenbank für Servicetechniker'
      />
      <meta
        name='twitter:description'
        content='Die intelligente Wissensdatenbank für Servicetechniker. Sparen Sie Zeit, reduzieren Sie Standzeiten und bewahren Sie wertvolles Know-how.'
      />
      <meta
        name='twitter:image'
        content='https://engknowledge.com/founder-photo.jpg'
      />

      {/* Canonical URL */}
      <link rel='canonical' href='https://engknowledge.com/' />

      {/* Additional SEO Tags */}
      <meta name='geo.region' content='DE' />
      <meta name='geo.placename' content='Deutschland' />
      <meta name='theme-color' content='#1976d2' />
    </Helmet>
  )
}

export default LandingMetaTags

